export class TaskDetail {
    constructor(taskId: number, groupId: number, name: string, statusText: string, lockable: boolean = false, plcLockable: boolean = false) {
        this.taskId = taskId;
        this.groupId = groupId;
        this.name = name;
        this.statusText = statusText;
        this.lockable = lockable;
        this.plcLockable = plcLockable;
    }

    public taskId: number;
    public groupId: number;
    public name: string;
    public status?: TaskDetailStatus;
    public statusText: string;
    public class?: string;
    public img?: string;
    public lockable: boolean;
    public plcLockable: boolean;

}

export enum TaskDetailStatus {
    Complete,
    Current,
    Waiting
}
